import { dashboardAPI } from "@/services";

export default {
  async logout({ commit }) {
    try {
      // Clear all localStorage items related to user session
      localStorage.removeItem("accessToken");
      localStorage.removeItem("accessUser");
      localStorage.removeItem("setSelectedEventId");
      localStorage.removeItem("setSelectedStallholderId");

      // Clear API headers
      dashboardAPI.clearHeaders();

      // Reset all Vuex store modules to initial state
      commit("resetAppState");
      commit("dashboard/resetDashboardState", null, { root: true });
      commit("filter/resetFilterState", null, { root: true });
      commit("admin/resetAdminState", null, { root: true });

      return Promise.resolve();
    } catch (error) {
      console.error("Error during logout cleanup:", error);
      return Promise.reject(error);
    }
  },
};
